/**
 * Pays (ISO) de l'association dont on affiche la page publique.
 *
 * Internationalisation, lot 3 (2026-09-25) : un téléphone tapé SANS indicatif
 * (« 0470 12 34 56 ») se lit dans le pays de l'association — validation des
 * formulaires, exemple montré, affichage et lien `tel:` (règle partagée
 * `@donoor/utils/telephone`).
 *
 * La PAGE (adhésion, billetterie, boutique) fournit le pays reçu de l'API
 * (`plan.country`, `event.country`, `shop.country`) ; les étapes du tunnel le
 * lisent sans qu'on le fasse descendre de prop en prop. Absent → « FR », le
 * comportement d'avant.
 */
import type { ComputedRef, InjectionKey, MaybeRefOrGetter } from "vue";
import { PAYS_PAR_DEFAUT } from "@donoor/utils";

const CLE_PAYS_ASSOCIATION: InjectionKey<ComputedRef<string>> = Symbol("pays-association");

/** À appeler dans la page : rend le pays disponible à tous ses composants. */
export function fournirPaysAssociation(
  pays: MaybeRefOrGetter<string | null | undefined>,
): ComputedRef<string> {
  const valeur = computed(() => toValue(pays) || PAYS_PAR_DEFAUT);
  provide(CLE_PAYS_ASSOCIATION, valeur);
  return valeur;
}

/** Pays de l'association de la page courante (« FR » hors d'une page d'asso). */
export function usePaysAssociation(): ComputedRef<string> {
  const fourni = inject(CLE_PAYS_ASSOCIATION, null);
  return computed(() => fourni?.value ?? PAYS_PAR_DEFAUT);
}
